var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationUpload.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationUpload.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "name", "isSmall"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("name", Object.prototype.hasOwnProperty.call(kwargs, "name") ? kwargs["name"] : "");frame.set("isSmall", Object.prototype.hasOwnProperty.call(kwargs, "isSmall") ? kwargs["isSmall"] : false);var t_5 = "";t_5 += "\n    <div class=\"ProductionDesignInitiativeApplicationUpload ";
if(runtime.contextOrFrameLookup(context, frame, "isSmall")) {
t_5 += "ProductionDesignInitiativeApplicationUpload--small";
;
}
t_5 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "data")) {
t_5 += "data-file=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "data"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " data-state=\"idle\" data-name=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
t_5 += "\">\n        <label class=\"ProductionDesignInitiativeApplicationUpload-label ProductionDesignInitiativeApplicationUpload-label--big\" for=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
t_5 += "\">Upload</label>\n        <div class=\"ProductionDesignInitiativeApplicationUpload-filename\"><span>File Uploaded:&nbsp;</span><a href=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "data"), env.opts.autoescape);
t_5 += "\" class=\"u-skipUrlParser\" target=\"_blank\">";
if(runtime.contextOrFrameLookup(context, frame, "data")) {
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "data"), env.opts.autoescape);
;
}
t_5 += "</a></div>\n        <label class=\"ProductionDesignInitiativeApplicationUpload-label ProductionDesignInitiativeApplicationUpload-label--small\" for=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
t_5 += "\">Upload New File</label>\n        <input type=\"file\" id=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
t_5 += "\" name=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
t_5 += "\" accept=\".pdf\">\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("ProductionDesignInitiativeApplicationUpload");
context.setVariable("ProductionDesignInitiativeApplicationUpload", macro_t_4);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationUpload.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationUpload.jinja
// module id = 125
// module chunks = 0